// Get reserve data response
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue8, FctValue40, FctValue128_27 } from '../../../../Fct/generics';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { LENDING_POOL_ADDRESSES } from '../constants';
export var GetReserveData = createPlugin({
    protocol: 'AAVE',
    type: 'GETTER',
    method: 'getReserveData',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveTokens({ chainId: chainId }) }),
                },
            },
            output: {
                configuration: new FctValue({ innerIndex: 0 }),
                liquidityIndex: new FctValue128_27({ innerIndex: 1 }),
                variableBorrowIndex: new FctValue128_27({ innerIndex: 2 }),
                currentLiquidityRate: new FctValue128_27({ innerIndex: 3 }),
                currentVariableBorrowRate: new FctValue128_27({ innerIndex: 4 }),
                currentStableBorrowRate: new FctValue128_27({ innerIndex: 5 }),
                lastUpdateTimestamp: new FctValue40({ innerIndex: 6 }),
                aTokenAddress: new FctAddress({ innerIndex: 7 }),
                stableDebtTokenAddress: new FctAddress({ innerIndex: 8 }),
                variableDebtTokenAddress: new FctAddress({ innerIndex: 9 }),
                interestRateStrategyAddress: new FctAddress({ innerIndex: 10 }),
                id: new FctValue8({ innerIndex: 11 }),
            },
        });
    },
});
